// extracted by mini-css-extract-plugin
export default {"personal":"details_personal__yXzdK","inputFlex":"details_inputFlex__2TLAk","section":"details_section__b01Oy"};